import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputMask, InputMaskChangeParams } from 'primereact/inputmask';

import { ModelOfBidding, ModelOfCreditor, ModelOfCreditorMaquina, ModelOfCreditorTipoCombustivel } from 'src/database';

import useIntersectionObserver from 'src/components/IntersectionObserver/useIntersectionObserver';
import LoadingScreen from '../../components/LoadingScreen';
import { useListCreditorsController, } from '../../controllers/Creditor/ListCreditorsController';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';
import { PulseLoader } from 'react-spinners';
import { Divider } from 'primereact/divider';
import { InputNumber } from 'primereact/inputnumber';
import { AutoComplete } from 'primereact/autocomplete';
import { dateToString } from 'src/utils/dateToString';
import { Tooltip } from 'primereact/tooltip';

interface InputMaskProps {
    label: string;
    mask: string;
    placeholder: string;
}

interface filteredProps {
    label: string;
    value?: string;
}

const CreditorsList: React.FC = () => {
    const { getCreditorListController, handleCreditorListController } = useListCreditorsController();
    const { fuels } = getCreditorListController
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [inputMask, setInputMask] = useState<InputMaskProps>({ label: 'CPF', mask: '999.999.999-99', placeholder: '___.___.___-__' });
    const [valueFuel, setValueFuel] = useState('');
    const [filteredFuels, setFilteredFuels] = useState<filteredProps[]>([{ label: '', value: '' }]);

    if (getCreditorListController.loading) {
        return <LoadingScreen />
    };

    const searchFuels = (event: any) => {
        let filteredFuels;
        if (!event.query.trim().length) {
            filteredFuels = [...fuels];
        } else {
            filteredFuels = fuels.filter(unity => {
                return unity.label.toLowerCase().includes(event.query.toLowerCase());
            });
        }
        setFilteredFuels(filteredFuels);
    };

    const maskOptions = [
        { label: 'CPF', mask: '999.999.999-99', placeholder: '___.___.___-__' },
        { label: 'CNPJ', mask: '99.999.999/9999-99', placeholder: '__.___.___/____-__' },
    ];

    const tableHeader = (
        <div className="table-header p-grid p-d-flex p-jc-between">
            <h5 className="p-m-0">Credores</h5>
            <span className="p-input-icon-left p-search-bar">
                <i className="pi pi-search" />
                <InputText type="search" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>
        </div>
    );

    const actionBodyTemplate = (Creditor: ModelOfCreditor) => {
        return (
            
            <React.Fragment>
                <Tooltip target=".unity-editarcredor-btn" content="Editar credor" position="top" />
                <Tooltip target=".unity-excluircredor-btn" content="Excluir credor" position="top" />
                <Tooltip target=".unity-maquinacredor-btn" content="Máquinas" position="top" />
                <Tooltip target=".unity-combustivelcredor-btn" content="Valores combustível" position="top" />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2 unity-editarcredor-btn" onClick={() => handleCreditorListController.openEditDialog(Creditor)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger unity-excluircredor-btn" onClick={() => handleCreditorListController.openDeleteDialog(Creditor)} />
                <Button icon="pi pi-paypal" className="p-button-rounded p-button-text p-button-success unity-maquinacredor-btn" onClick={() => handleCreditorListController.openMaquinaDialog(Creditor)} />
                <Button icon="pi pi-dollar" className="p-button-rounded p-button-text p-button-success unity-combustivelcredor-btn" onClick={() => handleCreditorListController.openTipoCombustivelDialog(Creditor)} />
            </React.Fragment>
        );
    };

    const actionBodyTemplateMaquina = (CreditorMaquina: ModelOfCreditorMaquina) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => handleCreditorListController.editCreditorMaquina(CreditorMaquina)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleCreditorListController.openDeleteMaquinaDialog(CreditorMaquina)} />
            </React.Fragment>
        );
    };

    const actionBodyTemplateTipoCombustivel = (CreditorTipoCombustivel: ModelOfCreditorTipoCombustivel) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => handleCreditorListController.editCreditorTipoCombustivel(CreditorTipoCombustivel)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleCreditorListController.openDeleteTipoCombustivelDialog(CreditorTipoCombustivel)} />
            </React.Fragment>
        );
    };

    const editCreditorDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleCreditorListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getCreditorListController.formik.handleSubmit() }} />
        </React.Fragment>
    );



    const deleteCreditorDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleCreditorListController.closeDeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getCreditorListController.selectedCreditor && handleCreditorListController.removeCreditor(getCreditorListController.selectedCreditor)
                }}
            />
        </React.Fragment>
    );

    const deleteCreditorMaquinaDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleCreditorListController.closeDeleteMaquinaDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getCreditorListController.selectedCreditorMaquina && handleCreditorListController.removeCreditorMaquina(getCreditorListController.selectedCreditorMaquina)
                }}
            />
        </React.Fragment>
    );

    const deleteCreditorTipoCombustivelDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleCreditorListController.closeDeleteTipoCombustivelDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getCreditorListController.selectedCreditorTipoCombustivel && handleCreditorListController.removeCreditorTipoCombustivel(getCreditorListController.selectedCreditorTipoCombustivel)
                }}
            />
        </React.Fragment>
    );

    const leftCreditorToolbar = () => {
        return (
            <Link to="/creditorForm">
                <Button label="Cadastrar credor" icon="pi pi-plus" className="p-button-success p-mr-2" />
            </Link>
        );
    };

    const HEADER_NOME = (rowData: ModelOfCreditor) => {
        return (
            <React.Fragment>
                <span className="left-header">NOME</span>
                {rowData.NOME}
            </React.Fragment>
        );
    }

    const HEADER_CPF_CNPJ = (rowData: ModelOfCreditor) => {
        return (
            <React.Fragment>
                <span className="left-header">CPF_CNPJ</span>
                {rowData.CPF_CNPJ}
            </React.Fragment>
        );
    }

    const HEADER_BANCO = (rowData: ModelOfCreditor) => {
        return (
            <React.Fragment>
                <span className="left-header">BANCO</span>
                {rowData.BANCO}
            </React.Fragment>
        );
    }

    const HEADER_AGENCIA = (rowData: ModelOfCreditor) => {
        return (
            <React.Fragment>
                <span className="left-header">AGENCIA</span>
                {rowData.AGENCIA}
            </React.Fragment>
        );
    }

    const HEADER_CONTA = (rowData: ModelOfCreditor) => {
        return (
            <React.Fragment>
                <span className="left-header">CONTA</span>
                {rowData.CONTA}
            </React.Fragment>
        );
    }

    const Loader: React.FC = ({ children }) => {
        const divRef: any = useRef<HTMLDivElement | null>(null);

        const [isVisible] = useIntersectionObserver({
            elementRef: divRef,
        });

        if (isVisible && !getCreditorListController.maxData && !getCreditorListController.loadingRows) {
            handleCreditorListController.setRows(getCreditorListController.rows + 20);
        };

        return (
            <div
                ref={divRef}
                style={{
                    minHeight: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {children}
            </div>
        )
    }

    const handleChangeCPFCNPJ = (e: InputMaskChangeParams) => {
        console.log("InputMaskChangeParams: ", e)
        console.log("InputMaskChangeParams: ", e.target)
        console.log("InputMaskChangeParams: ", e.target.value)
        console.log("InputMaskChangeParams: ", e.value)
        getCreditorListController.formik.setFieldValue('CPF_CNPJ', e.target.value);
    };

    const HEADER_DATAAUTORIZACAOCOMBUSTIVEL = (rowData: ModelOfCreditorTipoCombustivel) => {
        return (
            <React.Fragment>
                <span className="left-header">DATA AUTORIZAÇÃO</span>
                {dateToString(rowData.DATA, 'br')}
            </React.Fragment>
        )
    }

    const HEADER_VALORTIPOCOMBUSTIVEL = (rowData: ModelOfCreditorTipoCombustivel) => {
        const valueStyle: React.CSSProperties = {
            textAlign: 'right' as 'right', 
            display: 'block'
        };

        return (
            <React.Fragment>
                <span style={valueStyle}>
                    {Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(rowData?.VALOR || 0)}
                </span>
            </React.Fragment>
        );
    };

    return (
        <div>
            <Toast ref={getCreditorListController.toast} />
            <div className="p-card p-p-4 datatable-container">
                <Toolbar className="p-mb-4" left={leftCreditorToolbar}></Toolbar>

                <DataTable
                    header={tableHeader}
                    globalFilter={globalFilter} rowHover
                    className="responsive-table p-datatable-sm"
                    dataKey="ID" autoLayout scrollable scrollHeight={'100%'}
                    value={getCreditorListController.CreditorsData}
                >
                    <Column field="NOME" header="NOME" body={HEADER_NOME}></Column>
                    <Column field="CPF_CNPJ" header="CPF / CNPJ" body={HEADER_CPF_CNPJ}></Column>
                    <Column field="BANCO" header="BANCO" body={HEADER_BANCO}></Column>
                    <Column field="AGENCIA" header="AGENCIA" body={HEADER_AGENCIA}></Column>
                    <Column field="CONTA" header="CONTA" body={HEADER_CONTA}></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
                <Loader>{!getCreditorListController.maxData ?
                    getCreditorListController.loadingRows ? <PulseLoader color="#0388e5" size={8} /> : <></>
                    : "Lista completa"}
                </Loader>
            </div>



            <Dialog
                style={{ width: '60%' }}
                visible={getCreditorListController.maquinaDialog}
                onHide={handleCreditorListController.closeMaquinaDialog}
                onShow={() => {
                    getCreditorListController.formik.setValues(getCreditorListController.selectedCreditor);
                    getCreditorListController.getCreditorMaquinas()
                }}
                header={`Cadastro de máquinas - credor ${getCreditorListController.selectedCreditor?.NOME}`}
                modal
            >

                <div className="p-grid p-fluid">

                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="nomeCompMaquinaId" >Id da máquina</label>
                        <InputText id="nomeCompMaquinaId"
                            {...getCreditorListController.formikMaquina.getFieldProps('MAQUINAID')}
                            onChange={getCreditorListController.formikMaquina.handleChange('MAQUINAID')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getCreditorListController.formikMaquina.touched.MAQUINAID && getCreditorListController.formikMaquina.errors.MAQUINAID,
                            'popup-form-inactive': !(getCreditorListController.formikMaquina.touched.MAQUINAID && getCreditorListController.formikMaquina.errors.MAQUINAID),
                        })}
                        >{getCreditorListController.formikMaquina.errors.MAQUINAID}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-5">
                        <label htmlFor="nomeComp" >Descrição</label>
                        <InputText id="nomeComp"
                            {...getCreditorListController.formikMaquina.getFieldProps('DESCRICAO')}
                            onChange={getCreditorListController.formikMaquina.handleChange('DESCRICAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getCreditorListController.formikMaquina.touched.DESCRICAO && getCreditorListController.formikMaquina.errors.DESCRICAO,
                            'popup-form-inactive': !(getCreditorListController.formikMaquina.touched.DESCRICAO && getCreditorListController.formikMaquina.errors.DESCRICAO),
                        })}
                        >{getCreditorListController.formikMaquina.errors.DESCRICAO}</div>
                    </div>
                    <div className="p-col-12 p-md-3" style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px',
                        marginTop: '10px',
                        height: '100%',
                    }}>
                        <Button label="Salvar Maquina" icon="pi pi-save" onClick={() => { getCreditorListController.formikMaquina.handleSubmit() }} />
                    </div>
                    <div className='p-col-6 p-md-6'>
                        <label>Máquina(s) vinculado ao credor</label>
                    </div>
                    <Divider style={{ borderTop: '3px solid #191970', margin: '3px 0' }} />
                    <div className="p-card p-p-4 datatable-container">

                        <DataTable className="p-datatable-sm"
                            dataKey="ID" rowHover scrollable scrollHeight={'100%'}
                            value={getCreditorListController.CreditorMaquinasData}>
                            <Column field="MAQUINAID" header="Maquina"></Column>
                            <Column field="DESCRICAO" header="Descrição"></Column>
                            <Column body={actionBodyTemplateMaquina} bodyStyle={{ textAlign: 'right' }}></Column>

                        </DataTable>
                    </div>

                </div>
            </Dialog>

            <Dialog
                style={{ width: '60%' }}
                visible={getCreditorListController.tipoCombustivelDialog}
                onHide={handleCreditorListController.closeTipoCombustivelDialog}
                onShow={() => {
                    getCreditorListController.formik.setValues(getCreditorListController.selectedCreditor);
                    getCreditorListController.getCreditorTipoCombustivels()
                }}
                header={`Cadastro de tipo de combustível - credor ${getCreditorListController.selectedCreditor?.NOME}`}
                modal
            >

                <div className="p-grid p-fluid">
                    <div className='p-field p-col-12 p-md-12'>
                        <label htmlFor='descricao'>Tipo de Combustível</label>
                        <AutoComplete
                            id='COMBUSTIVEL'
                            value={valueFuel}
                            field='label'
                            onChange={e => {
                                setValueFuel(e.value.label);
                                getCreditorListController.formikTipoCombustivel.setFieldValue(
                                    'FT_TIPOCOMBUSTIVEL',
                                    filteredFuels.find(fuel => {
                                        return e.value === fuel.label;
                                    })?.value || '',
                                );
                            }}
                            onSelect={e => {
                                setValueFuel(e.value.label);
                                getCreditorListController.formikTipoCombustivel.setFieldValue('TIPOCOMBUSTIVEL', e.value.value);
                                console.log("tipo comb: ", e.value.value)
                            }}
                            suggestions={filteredFuels}
                            completeMethod={searchFuels}
                            dropdown
                            placeholder='Tipo de Combustível...'
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getCreditorListController.formikTipoCombustivel.touched.TIPOCOMBUSTIVEL && getCreditorListController.formikTipoCombustivel.errors.TIPOCOMBUSTIVEL,
                            'popup-form-inactive': !(getCreditorListController.formikTipoCombustivel.touched.TIPOCOMBUSTIVEL && getCreditorListController.formikTipoCombustivel.errors.TIPOCOMBUSTIVEL),
                        })}
                        >{getCreditorListController.formikTipoCombustivel.errors.TIPOCOMBUSTIVEL}</div>
                    </div>

                    <div className='p-grid p-col-12 p-md-12'>
                        <div className='p-col-6 p-md-6'>
                            <label htmlFor='descricao'>Data Autorização</label>
                            <InputMask
                                type={'text'}
                                mask='99/99/9999'
                                value={getCreditorListController.formikTipoCombustivel.values.DATA}
                                onChange={e => {
                                    getCreditorListController.formikTipoCombustivel.setFieldValue('DATA', e.target.value);
                                }}
                                placeholder='__/__/____'
                            />
                            <div className={classNames("p-invalid popup-fade", {
                                'popup-form-active': getCreditorListController.formikTipoCombustivel.touched.DATA && getCreditorListController.formikTipoCombustivel.errors.DATA,
                                'popup-form-inactive': !(getCreditorListController.formikTipoCombustivel.touched.DATA && getCreditorListController.formikTipoCombustivel.errors.DATA),
                            })}
                            >{getCreditorListController.formikTipoCombustivel.errors.DATA}</div>
                        </div>

                        <div className='p-col-6 p-md-6'>
                            <label htmlFor='descricao'>Valor</label>
                            <InputNumber
                                id='valorAutorizacao'
                                {...getCreditorListController.formikTipoCombustivel.getFieldProps('VALOR')}
                                onChange={e => getCreditorListController.formikTipoCombustivel.setFieldValue('VALOR', e.value)}
                                mode='currency'
                                currency='BRL'
                                locale='pt-BR'
                            />
                            <div className={classNames("p-invalid popup-fade", {
                                'popup-form-active': getCreditorListController.formikTipoCombustivel.touched.VALOR && getCreditorListController.formikTipoCombustivel.errors.VALOR,
                                'popup-form-inactive': !(getCreditorListController.formikTipoCombustivel.touched.VALOR && getCreditorListController.formikTipoCombustivel.errors.VALOR),
                            })}
                            >{getCreditorListController.formikTipoCombustivel.errors.VALOR}</div>
                        </div>
                    </div>


                    <div className="p-col-12 p-md-3" style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px',
                        marginTop: '10px',
                        height: '100%',
                    }}>
                        <Button label="Salvar Combustível" icon="pi pi-save" onClick={() => { getCreditorListController.formikTipoCombustivel.handleSubmit() }} />
                    </div>
                    <div className='p-col-6 p-md-6'>
                        <label>Combustivel(s) vinculado ao credor</label>
                    </div>
                    <Divider style={{ borderTop: '3px solid #191970', margin: '3px 0' }} />
                    <div className="p-card p-p-4 datatable-container">

                        <DataTable className="p-datatable-sm"
                            dataKey="ID" rowHover scrollable scrollHeight={'100%'}
                            value={getCreditorListController.CreditorTipoCombustivelsData}>
                            <Column field="DATA" header="Data" body={HEADER_DATAAUTORIZACAOCOMBUSTIVEL}></Column>
                            <Column field="TIPOCOMBUSTIVELDESCRICAO" header="Tipo Combustível"></Column>
                            <Column field="VALOR" header="Valor" body={HEADER_VALORTIPOCOMBUSTIVEL}></Column>
                            <Column body={actionBodyTemplateTipoCombustivel} bodyStyle={{ textAlign: 'right' }}></Column>

                        </DataTable>
                    </div>

                </div>
            </Dialog>

            <Dialog
                className="p-fluid"
                style={{ width: '90%' }}
                visible={getCreditorListController.editDialog}
                onHide={handleCreditorListController.closeEditDialog}
                onShow={() => {
                    getCreditorListController.formik.setValues(getCreditorListController.selectedCreditor);
                    if (getCreditorListController.selectedCreditor.CPF_CNPJ
                        && getCreditorListController.selectedCreditor.CPF_CNPJ.length <= 14) {
                        setInputMask(maskOptions[0]);
                    } else {
                        setInputMask(maskOptions[1]);
                    }
                }}
                footer={editCreditorDialogFooter}
                header={`Editar credor ${getCreditorListController.selectedCreditor?.NOME}`}
                modal
            >
                {getCreditorListController.loadingEdit ? <LoadingScreen color="#0388e5" /> : <></>}
                <div className="p-grid p-fluid">
                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="cpf" >CPF / CNPJ</label>
                        <InputMask id="cpf" disabled
                            mask='99.999.999/9999-99'
                            {...getCreditorListController.formik.getFieldProps('CPF_CNPJ')}
                            onChange={handleChangeCPFCNPJ}>

                            {(inputProps: any) => (
                                <input
                                    {...inputProps}
                                    id="cpf"
                                    name="CPF_CNPJ"
                                    disabled={false}
                                />
                            )}

                        </InputMask>

                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getCreditorListController.formik.touched.CPF_CNPJ && getCreditorListController.formik.errors.CPF_CNPJ,
                            'popup-form-inactive': !(getCreditorListController.formik.touched.CPF_CNPJ && getCreditorListController.formik.errors.CPF_CNPJ),
                        })}
                        >{getCreditorListController.formik.errors.CPF_CNPJ}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-8">
                        <label htmlFor="nomeComp" >Nome completo</label>
                        <InputText id="nomeComp"
                            {...getCreditorListController.formik.getFieldProps('NOME')}
                            onChange={getCreditorListController.formik.handleChange('NOME')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getCreditorListController.formik.touched.NOME && getCreditorListController.formik.errors.NOME,
                            'popup-form-inactive': !(getCreditorListController.formik.touched.NOME && getCreditorListController.formik.errors.NOME),
                        })}
                        >{getCreditorListController.formik.errors.NOME}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="banco" >Banco</label>
                        <InputText id="banco" maxLength={150}
                            {...getCreditorListController.formik.getFieldProps('BANCO')}
                            onChange={getCreditorListController.formik.handleChange('BANCO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getCreditorListController.formik.touched.BANCO && getCreditorListController.formik.errors.BANCO,
                            'popup-form-inactive': !(getCreditorListController.formik.touched.BANCO && getCreditorListController.formik.errors.BANCO),
                        })}
                        >{getCreditorListController.formik.errors.BANCO}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="agencia" >Agencia</label>
                        <InputText id="agencia" maxLength={20}
                            {...getCreditorListController.formik.getFieldProps('AGENCIA')}
                            onChange={getCreditorListController.formik.handleChange('AGENCIA')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getCreditorListController.formik.touched.AGENCIA && getCreditorListController.formik.errors.AGENCIA,
                            'popup-form-inactive': !(getCreditorListController.formik.touched.AGENCIA && getCreditorListController.formik.errors.AGENCIA),
                        })}
                        >{getCreditorListController.formik.errors.AGENCIA}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="conta" >Conta</label>
                        <InputText id="conta" maxLength={20} placeholder="________-_"
                            {...getCreditorListController.formik.getFieldProps('CONTA')}
                            onChange={(e) => getCreditorListController.formik.setFieldValue('CONTA', e.currentTarget.value)}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getCreditorListController.formik.touched.CONTA && getCreditorListController.formik.errors.CONTA,
                            'popup-form-inactive': !(getCreditorListController.formik.touched.CONTA && getCreditorListController.formik.errors.CONTA),
                        })}
                        >{getCreditorListController.formik.errors.CONTA}</div>
                    </div>

                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getCreditorListController.deleteDialog}
                onHide={handleCreditorListController.closeDeleteDialog}
                footer={deleteCreditorDialogFooter}
                header="Remover credor"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getCreditorListController.selectedCreditor && <span>Você tem certeza que deseja remover <b>{getCreditorListController.selectedCreditor.NOME}</b>?</span>}
                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getCreditorListController.deleteMaquinaDialog}
                onHide={handleCreditorListController.closeDeleteMaquinaDialog}
                footer={deleteCreditorMaquinaDialogFooter}
                header="Remover máquina"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getCreditorListController.selectedCreditorMaquina && <span>Você tem certeza que deseja remover <b>{getCreditorListController.selectedCreditorMaquina.DESCRICAO}</b>?</span>}
                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getCreditorListController.deleteTipoCombustivelDialog}
                onHide={handleCreditorListController.closeDeleteTipoCombustivelDialog}
                footer={deleteCreditorTipoCombustivelDialogFooter}
                header="Remover tipo combustível"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getCreditorListController.selectedCreditorTipoCombustivel && <span>Você tem certeza que deseja remover <b>{getCreditorListController.selectedCreditorTipoCombustivel.TIPOCOMBUSTIVEL}</b>?</span>}
                </div>
            </Dialog>
        </div>

    );
};

export default CreditorsList;